// Material 3 segmented button (single select): connected outlined segments; the selected one is secondary-container with a check.
// Props: options [{ value, label, icon? }], value, onChange(value), ariaLabel, fullWidth, size ('medium' 40dp | 'small' 32dp, for editor toolbars)
(function () {
  const { ButtonBase, Box } = MaterialUI;

  function SegmentedButton({ options = [], value, onChange, ariaLabel = 'Options', fullWidth = false, size = 'medium', sx }) {
    const small = size === 'small';
    const { GoogleIcon } = window.Components;
    const motion = 'var(--m3-duration-short) var(--m3-easing-standard)';
    return (
      <Box
        role="radiogroup"
        aria-label={ariaLabel}
        // Equal segments as wide as the widest one (label + check mark), so selecting never clips a label or shifts the row
        sx={[{ display: fullWidth ? 'grid' : 'inline-grid', gridAutoFlow: 'column', gridAutoColumns: '1fr', width: fullWidth ? '100%' : 'auto', height: small ? 32 : 40, flexShrink: 0 }, ...(Array.isArray(sx) ? sx : [sx])]}
      >
        {options.map((o, i) => {
          const selected = o.value === value;
          const first = i === 0;
          const last = i === options.length - 1;
          return (
            <ButtonBase
              key={o.value}
              role="radio"
              aria-checked={selected}
              onClick={() => onChange(o.value)}
              sx={{
                position: 'relative',
                minWidth: 0,
                px: small ? 2 : 2.5,
                gap: small ? 1 : 1.25,
                whiteSpace: 'nowrap',
                border: '1px solid var(--m3-outline)',
                ml: first ? 0 : '-1px',
                borderRadius: `${first ? 'var(--m3-shape-full)' : '0'} ${last ? 'var(--m3-shape-full)' : '0'} ${last ? 'var(--m3-shape-full)' : '0'} ${first ? 'var(--m3-shape-full)' : '0'}`,
                backgroundColor: selected ? 'var(--m3-secondary-container)' : 'transparent',
                color: selected ? 'var(--m3-on-secondary-container)' : 'var(--m3-on-surface)',
                fontFamily: 'inherit',
                fontSize: '0.875rem',
                fontWeight: 500,
                letterSpacing: '0.1px',
                transition: `background-color ${motion}`,
                // Touch screens: tap area grows to 44dp tall
                '@media (pointer: coarse)': { '&::after': { content: '""', position: 'absolute', inset: '-2px 0' } },
                '&::before': { content: '""', position: 'absolute', inset: 0, borderRadius: 'inherit', backgroundColor: 'currentColor', opacity: 0, transition: `opacity ${motion}` },
                '&:hover::before': { opacity: 'var(--m3-state-hover)' },
                '&:focus-visible::before': { opacity: 'var(--m3-state-focus)' },
                '&:focus-visible': { outline: '3px solid var(--m3-secondary)', outlineOffset: 2, zIndex: 1 }
              }}
            >
              {/* the visible content and, stacked under it invisibly, the selected form (check + label): it sets the width */}
              <Box component="span" sx={{ display: 'grid', placeItems: 'center' }}>
                <Box component="span" sx={{ gridArea: '1 / 1', display: 'inline-flex', alignItems: 'center', gap: small ? 1 : 1.25 }}>
                  {selected ? <GoogleIcon name="check" size={18} style={{ color: 'inherit' }} /> : o.icon ? <GoogleIcon name={o.icon} size={18} style={{ color: 'inherit' }} /> : null}
                  {o.label}
                </Box>
                <Box component="span" aria-hidden="true" sx={{ gridArea: '1 / 1', visibility: 'hidden', display: 'inline-flex', alignItems: 'center', gap: small ? 1 : 1.25 }}>
                  <GoogleIcon name="check" size={18} />{o.label}
                </Box>
              </Box>
            </ButtonBase>
          );
        })}
      </Box>
    );
  }

  window.Components = window.Components || {};
  window.Components.SegmentedButton = SegmentedButton;
})();
